import React, { Component } from 'react';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Clear from '@material-ui/icons/Clear';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';

import AttachFileOutlined from '@material-ui/icons/AttachFileOutlined';

import Button from 'components/CustomButtons/Button';
import CustomInput from 'components/CustomInput/CustomInput';

const styles = {
	pathInput: {
		width: 'calc(100% - 48px)',
		marginLeft: '5px',
	},
};

class LogoUpload extends Component {

	state = {
		filePath: '',
		isError: false,
		helperText: '',
	};

	defaultHint = 'File size max 1 Mb, type: jpg/png, 640 * 960 px';

	componentDidMount() {
		this.setState({
			helperText: this.props.hint || this.defaultHint,
		});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.isUnsaved !== this.props.isUnsaved && !this.props.isUnsaved) {
			this.handleClear();
		}
	}

	fileInput = React.createRef();

	handleClick = () => {
		this.fileInput.current.click();
	};

	handleClear = () => {
		this.fileInput.current.value = null;

		const {
			onImageChange,
		} = this.props;

		onImageChange(null, null);

		this.setState({
			filePath: '',
			isError: false,
			helperText: this.props.hint || this.defaultHint,
		})
	}

	handleImageChange = (event) => {
		const {
			allowedFormats,
			maxSize,
			resolution: {
				width,
				height,
				maxWidth,
				maxHeight,
				minWidth,
				minHeight,
			},
			onImageChange,
			skipFileValidation,
		} = this.props;

		event.preventDefault();

		const maxAllowedSize = maxSize * 1024 * 1024;

		const updatePath = (path) => {
			this.setState({
				filePath: path,
			});
		};

		const setValidationErrorMessage = () => {
			const logoValidationError = this.props.validationError || `For the best Logo display, please, upload a file max ${maxSize} Mb, type: ${allowedFormats}, ${width}*${height}px`;
			this.setState({
				isError: true,
				helperText: logoValidationError,
			})
		}

		const resetError = () => {
			this.setState({
				isError: false,
				helperText: this.props.hint || this.defaultHint,
			})
		}

		let newFile = event.target.files[0];

		if (newFile) {
			const fileType = newFile.type.split('/')?.[1];

			if (allowedFormats.indexOf(fileType) === -1) {
				setValidationErrorMessage();
				return;
			}

			if (newFile.size > maxAllowedSize) {
				setValidationErrorMessage();
				return;
			}

			let reader = new FileReader();
			reader.onloadend = () => {
				const image = new Image();
				image.src = reader.result;

				image.onload = function () {
					const imgHeight = this.height;
					const imgWidth = this.width;

					if (skipFileValidation && (skipFileValidation === true || skipFileValidation === 'true')) {
						updatePath(newFile.name);
						onImageChange(newFile, reader.result);
						resetError();
					} else if (
						(width && imgWidth !== width)
						|| (maxWidth && imgWidth > maxWidth)
						|| (minWidth && imgWidth < minWidth)
						|| (height && imgHeight !== height)
						|| (maxHeight && imgHeight > maxHeight)
						|| (minHeight && imgHeight < minHeight)
					) {
						setValidationErrorMessage();
					} else {
						updatePath(newFile.name);
						onImageChange(newFile, reader.result);
						resetError();
					}
				};
			};
			reader.readAsDataURL(newFile);
		} else {
			updatePath('');
			onImageChange(null, null);
		}
	};

	render() {
		const { classes, label, allowedFormats, isUnsaved, tooltip, disabled } = this.props;
		const { filePath, isError, helperText } = this.state;

		return (
			<div disabled={disabled} className="logo-upload-container">
				<Tooltip
					arrow
					title={tooltip || "Click to Upload Logo"} >
					<Button justIcon
						round
						color="warning"
						onClick={this.handleClick}
						disabled={disabled}
					>
						<AttachFileOutlined />
					</Button>
				</Tooltip>
				<CustomInput
					disabled={disabled}
					labelText={label}
					error={isError}
					helperText={isError || !isUnsaved ? helperText : ''}
					formControlProps={{
						fullWidth: true,
						className: classes.pathInput,
					}}
					inputProps={{
						disabled: true,
						value: isUnsaved ? filePath : '',
						type: "text",
						endAdornment: isUnsaved && (
							<InputAdornment
								position="end"
							>
								<Button
									justIcon
									simple
									onClick={this.handleClear}
								>
									<Clear />
								</Button>
							</InputAdornment>
						)
					}}
				/>
				<input
					type="file"
					accept={allowedFormats}
					onChange={(e) => this.handleImageChange(e)}
					ref={this.fileInput} />
			</div>
		);
	}
}

export default withStyles(styles)(LogoUpload);
